<template>
  <inline-message
    info
    :text="text || $t('no_results_found')"
    :has-close="false"
  />
</template>

<script>
import InlineMessage from '@components/Message/InlineMessage.vue'
export default {
  components: {
    InlineMessage,
  },
  props: {
    text: {
      type: String,
      default: null,
    },
  },
}
</script>
